module.exports = __webpack_public_path__ + "static/selling-5fc41a2fff27e4030669597e602a54c8.svg";